import { render, staticRenderFns } from "./AddFormSign.vue?vue&type=template&id=5c5ccf2b&scoped=true"
import script from "./AddFormSign.vue?vue&type=script&lang=js"
export * from "./AddFormSign.vue?vue&type=script&lang=js"
import style0 from "./AddFormSign.vue?vue&type=style&index=0&id=5c5ccf2b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c5ccf2b",
  null
  
)

export default component.exports